import { render, staticRenderFns } from "./PriceTypes.vue?vue&type=template&id=bef63768"
import script from "./PriceTypes.vue?vue&type=script&lang=js"
export * from "./PriceTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports